import React, {useEffect, useRef, useState} from 'react';
import {Box, Grid, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OtpInput from 'react-otp-input';
import {GetState} from "../../../../../../redux/reduxhelper";
import {USER_DATA} from "../../../../../../redux/action/type.action";
import {useDispatch} from "react-redux";


const LoginByOtpStep2 = ({setSlideIndex,pageIndex}) => {
    const userData = GetState(USER_DATA,{});
    const dispatch = useDispatch();
    console.log('pageIndex', pageIndex)
    const [otp, setOtp] = useState('');
    const [otpRetry, setOtpRetry] = useState(120);
    const handleChange = (otp) => setOtp(otp);
    const MY_INDEX = 2;
    let tmr = useRef(null);

    function startTimer(duration, display) {
        let timer = duration, minutes, seconds;
        return setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds;

            if (--timer < 0) {
                clearInterval(tmr?.current);
                setOtpRetry(0)
            }
        }, 1000);
    }

    useEffect(() => {
        if (pageIndex !== MY_INDEX) {
            try {
                clearInterval(tmr?.current)
            } catch (e) {
                // log error
            }
            return;
        }
        if (otpRetry <= 0) return;
        let display = document.querySelector('#time');
        tmr.current = startTimer(otpRetry, display);
    }, [pageIndex, otpRetry]);


    return (

        <Grid container sx={{justifyContent:'center',}} >


            <Box

                sx={{
                    my: 8,
                    mx: 4,
                    flexDirection: 'column',
                    width: {xs:'null',md:'60%'},
                    display:'flex'

                }}
            >


                <Grid sx={{textAlign:'end'}}>
                    <Link onClick={()=>setSlideIndex(1)}
                          underline="none" href="#"
                          variant="body2">
                        <KeyboardBackspaceIcon/>
                    </Link>
                </Grid>

                <Grid sx={{textAlign: 'center', mb: 4,}}>
                    <Typography>
                        رمز یکبار مصرف را وارد کنید
                    </Typography>
                    <Typography>
                       {userData?.mobile}
                    </Typography>
                </Grid>


                <Box component="form" noValidate  >

                    <OtpInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={4}
                        renderSeparator={<span style={{marginLeft:'.5rem'}}>  </span>}
                        isInputNum={true}
                        shouldAutoFocus={true}
                        renderInput={(props) => <input {...props} />}
                        containerStyle={{
                            justifyContent: 'center'
                        }}
                        inputStyle={{
                            border: "1px solid blue",
                            borderRadius: "40px",
                            width: '50px',
                            height: '50px',
                            fontSize: "12px",
                            color: "#592EA9",
                            fontWeight: "400",
                            caretColor: "blue"
                        }}
                        focusStyle={{
                            border: "1px solid #CFD3DB",
                            // outline: "none"
                        }}
                    />

                    <Grid sx={{textAlign: 'center', gap: 4, mt: 4}}>
                        <Typography>زمان باقی مانده</Typography>
                        {otpRetry > 0 && <span id="time">{''}</span>}

                        {otpRetry <= 0 && <span onClick={() => {
                            alert('ارسال مجدد انجام شد');
                            setOtpRetry(120)
                        }}><Button variant={"outlined"}>ارسال مجدد</Button></span>}
                    </Grid>
                    <Stack justifyContent={'center'} direction={'row'} alignItems={'center'} sx={{width:'100%'}}>
                        <Button
                            onClick={() => setSlideIndex(0)}
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                my: 2,
                                padding: '12px',
                                borderRadius: '40px',
                                backgroundColor: '#592EA9',
                                ":hover": {bgcolor: '#5D5FEF'}
                            }}
                        >
                           ثبت رمز یکبار مصرف
                        </Button>
                    </Stack>


                    <Grid sx={{
                        width: '100%',
                        display: {xs: 'grid', sm: 'grid', md: 'flex'},
                        justifyContent: {xs: 'start', sm: 'start', md: 'space-between'},
                        textAlign: {xs: 'start', sm: 'start'}
                    }}>

                        <Link sx={{color: '#797979'}} underline="none" variant="body2">
                            برای شما کد ارسال نشده است؟
                        </Link>


                        <Link onClick={() => {
                            alert('ارسال مجدد انجام شد');
                            setOtpRetry(120)}}
                              underline="always" href="#" variant="body2">  {otpRetry > 0 && <span id="time">{''}</span>}
                            {"ارسال مجدد"}
                        </Link>

                    </Grid>
                </Box>
            </Box>
        </Grid>
    );
};

export default LoginByOtpStep2;
